import {
  Alert,
  Badge,
  Box,
  LinearProgress,
  linearProgressClasses,
  styled,
  Typography,
} from "@mui/material";
import { AREA_RATIO } from "../../../constants/global.constants";
import { TEXT } from "../../../constants/text";
import { useUserContext } from "../../../services/context/user-context";

const BorderLinearProgress = styled(LinearProgress)(
  ({ theme, error }) => ({
    height: "12px",
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[200],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: error ? "#ba1a1a" : "#efa21e",
    },
  })
);

export const AreaProgressBar = ({ buildingAreaSum, propertyArea }) => {
  const { userData } = useUserContext();
  const areaRule = userData.isAdmin ? 100 : AREA_RATIO;
  const progressValue =
    buildingAreaSum > propertyArea
      ? 100
      : (buildingAreaSum / propertyArea) * 100;

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          gap: "8px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography color="#a3aed0" fontSize={"12px"}>
        {TEXT.planner.progressBuildingsTitle}
        </Typography>

        <Typography color="#a3aed0" fontSize={"12px"}>
          {TEXT.planner.progressSiteTitle}
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100%",
          position: "relative",
        }}
      >
        <BorderLinearProgress
          variant="determinate"
          value={progressValue}
          error={progressValue >= areaRule ? 'true' : null}
        />
        {progressValue > 10 && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: `${progressValue}%`,
              /* background: "#efa21e",
            top: '-6px',
            left: "79%",
            width: "8px",
            height: "22px",
            border: '2px solid #eeeeee',
            borderRadius: '4px' */
            }}
          >
            <Typography
              color="#fff"
              textAlign={"center"}
              fontSize={"10px"}
              lineHeight={1.3}
            >
              {buildingAreaSum > propertyArea && ">"}
              {progressValue.toFixed()}%
            </Typography>
          </Box>
        )}
      </Box>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          gap: "8px",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          color={progressValue > areaRule ? "#ba1a1a" : "#efa21e"}
          fontSize={"12px"}
        >
          {buildingAreaSum.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} m²
        </Typography>
        <Typography color="#a3aed0" fontSize={"12px"}>
          {propertyArea.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} m²
        </Typography>
      </Box>
      {progressValue > areaRule && (
        <Box
          sx={{
            width: "100%",
            position: "relative",
            margin: "0 auto",
            paddingTop: "16px",
          }}
        >
          <Alert severity={"error"} sx={{ width: "100%", fontSize:'12px' }}>
            The total area of all buildings cannot exceed {areaRule}% of the site area.
            Please adjust the values.
          </Alert>
        </Box>
      )}
    </Box>
  );
};
